<template>
  <div id="myTable">
    <!--表格的标题-->
    <div id="title">{{title}}</div>
<!--    <slot name="title"></slot>-->
    <!--功能栏-->
    <div id="func">
<!--      <download-excel-->
<!--              class = "export-excel-wrapper"-->
<!--              :data = "tableData.list"-->
<!--              :fields = "tableField"-->
<!--              name = "title.xls">-->
<!--        &lt;!&ndash; 上面可以自定义自己的样式，还可以引用其他组件button &ndash;&gt;-->
<!--        <el-button class="button" @click="getExcl">按当前筛选条件导出表格</el-button>-->
<!--      </download-excel>-->
      <el-button class="button" v-if="isAdd" @click="add">新增</el-button>
      <div class="singleSearch" v-if="isSingleSearch">
        <el-select v-model="singleSearchValue" placeholder="请选择单一筛选条件" @change="singleSearch">
          <el-option
                  v-for="item in singleSearchArr"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key">
          </el-option>
        </el-select>
      </div>
    </div>
    <!--表格数据搜索条件-->
    <my-search :searchParams="searchParams" @search="search" v-if="isSearch"></my-search>
    <!--表格-->
    <div id="table">
      <slot name="table"></slot>
    </div>
    <div id="pagingInfo">
      <div id="count">
        <p>第 {{(tableData.pageNum-1)*10 + 1 }} 到 {{tableData.pageNum*10}} 行， 总共 {{tableData.total}} 行</p>
      </div>
      <div id="pageNum">
        <el-pagination
                background
                layout="prev, pager, next"
                :total="tableData.total" @current-change="pageNumChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import MySearch from "../mySearch/MySearch";
  export default {
    name: "MyTable",
    props:{
      //标题
      title: String,
      //是否需要添加按钮
      isAdd: {
        type: Boolean,
        default: false
      },
      //是否需要搜查
      isSearch: {
        type: Boolean,
        default: true
      },
      //单一搜查数组
      singleSearchArr: {
        type: Array
      },
      //是否需要单一搜查
      isSingleSearch: {
        type: Boolean,
        default: false
      },
      //搜查数组
      searchParams: Array,
      //包含分页信息的数据
      tableData : Object,
      //excl表格的头信息
      // tableField: {
      //   type: Object
      // }
    },
    data(){
      return{
        singleSearchValue: ''
      }
    },
    methods:{
      pageNumChange(pageNum){
        this.$emit("pageNumChange",pageNum);
      },
      search(searchItems){
        this.$emit("search",searchItems)
      },
      add(){
        this.$emit("add")
      },
      singleSearch(value){
        console.log(value);
        this.$emit("singleSearch",value)
      },
      // getExcl(){
      //   this.$emit("getExcl")
      // }
    },
    components: {MySearch}
  }
</script>

<style scoped>
  #title{
    height: 45px;
    line-height: 45px;
    border-bottom: 1px solid #d1d4d7;
    padding-left: 1.25rem;
    background-color: #f8f9fa;
    color: #2a2c36;
  }

  #myTable{
    margin-right: 15px;;
    margin-bottom: 15px;
    margin-left: 200px;
    background-color: #fff;
    font-size: 0.875rem;
  }

  #table{
    padding: 15px;
  }

  #pagingInfo{
    position: relative;
    margin-top: 15px;
    padding-bottom: 15px;
    height: 60px;
  }

  #count{
    display: inline-block;
    margin-left: 15px;
    height: 48px;
  }

  #pageNum{
    display: inline-block;
    vertical-align: middle;
    position: absolute;
    right: 15px;
  }

  #func{
    margin-left: 15px;
    margin-top: 20px;
  }

  #func .button{
    background-color: #20a8d8;
    color: #ffffff;
    border-radius: 0;
    display: inline-block;
  }

  .singleSearch{
    margin-left: 10px;
    display: inline-block;
  }
</style>
